import Papa from 'papaparse';
import textVersion from 'textversionjs';
import {downloadCSV} from "../Reports/ReportHelpers";
import {SECTION_TITLES} from '../containers/AnswersList';
import {createOptionSectionLookup} from '../reducer';
import {getSortIndex} from '../sortIndex';
//import {fetchNextResponsesPage} from '../actions/responses';
import {assessmentTiers} from "../components/resultItems/AssessmentTier";
import {getQuestionSections} from "../reducer/response";
//report name constants
export const Q_ORDER_SECTIONS_RPT = "qInOrderBySectionRpt";
export const Q_ORDER_RPT = "qInOrderRpt";
export const CAV_LINKS_RPT = "cavByOptionQuestionRpt";
export const CRIT_LINKS_RPT = "critByOptionQuestionRpt";
export const OPT_RPT = "optionsRpt";
export const Q_RPT = "questionsRpt";
export const ANS_RPT = "answersRpt";
export const CAV_RPT = "caveatsRpt";
export const CRIT_RPT = "criteriaRpt";
export const STAT_CAV_RPT = "staticCavRpt";

const allSections = ["monitoring", "assessment", "controlRules", "enforcement"];

export function getReport(report){

  return {
    description: getRptInfo(report).desc,
    downloadFunc: getRptInfo(report).dlFunc,
    columns: getRptInfo(report).cols,
    sections: getRptInfo(report).sections,
    multiSections: getRptInfo(report).multi
  };
}

const getRptInfo = (report) => {
  switch (report){
    case Q_ORDER_SECTIONS_RPT:
      return {
        desc: qInOrderBySectionDesc,
        cols: qInOrderBySectionCols,
        sections: ["monitoring,assessment,controlRules",
                   "monitoring,controlRules,assessment",
                   "assessment,monitoring,controlRules",
                   "assessment,controlRules,monitoring",
                   "controlRules,monitoring,assessment",
                   "controlRules,assessment,monitoring"],
        multi: false,
        dlFunc: dlQInOrderBySection
      };
    case Q_ORDER_RPT:
      return {
        desc: qOrderDesc,
        cols: questionOrderCols,
        sections: allSections,
        multi: true,
        dlFunc: dlQInOrder
      };
    case CAV_LINKS_RPT:
      return {
        desc: cavOptQDesc,
        cols: [],
        sections: allSections,
        multi: false,
        dlFunc: dlCavByOptionQuestion
      };
    case CRIT_LINKS_RPT:
      return {
        desc: critOptQDesc,
        cols: [],
        sections: ["monitoring", "assessment", "enforcement"],
        multi: false,
        dlFunc: dlCritByOptionQuestion
      };
    case OPT_RPT:
      return {
        desc: optDesc,
        cols: optionCols,
        sections: allSections,
        multi: true,
        dlFunc: dlOptions
      };
    case Q_RPT:
      return {
        desc: questionDesc,
        cols: questionCols,
        sections: allSections,
        multi: true,
        dlFunc: dlQuestions
      };
    case ANS_RPT:
      return {
        desc: ansDesc,
        cols: answerCols,
        sections: allSections,
        multi: true,
        dlFunc: dlAnswers
      };
    case CAV_RPT:
      return {
        desc: cavDesc,
        cols: caveatCols,
        sections: allSections,
        multi: true,
        dlFunc: dlCaveats
      };
    case CRIT_RPT:
      return {
        desc: critDesc,
        cols: criteriaCols,
        sections: ["monitoring", "assessment"],
        multi: true,
        dlFunc: dlCriteria
      };
    case STAT_CAV_RPT:
      return {
        desc: staticCavDesc,
        cols: staticCavCols,
        sections: allSections,
        multi: true,
        dlFunc: dlStaticCavs
      };
    default:
      return {
        desc: "Error loading report."
      }
  }
}


//Export descriptions
const cavOptQDesc = "Contains each option listed as a row and each question as a column. The corresponding " +
  "cells contain caveats that are triggered by each answer for that question and option. Static caveats are also included.\n\n" +
  "Caveats are structured as following. [Color]:[Answer]:[Caveat]";

const critOptQDesc = "Contains each option listed as a row and each question as a column. If the question is a " +
  "criteria for the option, then the corresponding cells contain each answer that satisfy the criteria.";

const ansDesc = "Lists all possible answers for each question."

const optDesc = "Lists all the options for each section."

const cavDesc = "Lists all the caveats for each section. Note that this will NOT list static caveats."

const staticCavDesc = "Lists all the static caveats for each section."

const  critDesc = "Lists all the criteria for each section."

const questionDesc = "Lists all the questions for each section."

const qOrderDesc = "Lists the questions in the order that they appear in the questionnaire for each section. Note that if a question has already " +
  "been answered in another section, then it will not appear again in the questionnaire. For this report, each question will appear in all sections that it is included in. " +
  "Use the \"All Sections for Question\" column to see each section that the question could be asked in.\n" +
  "Sort index is data that is used for software testing purposes."

const qInOrderBySectionDesc = "Lists the questions in the order that they appear when answering the questionnaire using the section order specified below. " +
  "This report assumes that every question is answered in a section before moving on to the next and therefore any question answered in a section will not appear again in the following section(s)."

//Export data columns
const optionCols = ["Option ID", "Option Title", "Description", "Assessment Output", "Contacts", "References", "Category (Output for Assessments)", "Input Category (Assessments Only)", "Tier (Assessments Only)", "Section"];
const staticCavCols = ["Option ID", "Option Title", "Static Caveat", "Score", "Category", "Section"];
const questionCols = ["Question ID", "Question", "Description", "Category", "Representation/Implementation", "Sections", "Answers"];
const caveatCols = ["Question ID", "Question", "Answer ID", "Answer", "Caveat", "Score", "Option ID", "Option", "Category", "Section"];
const answerCols = ["Question ID", "Question", "Answer ID", "Answer", "Sections"];
const criteriaCols = ["Question ID", "Question", "Valid Answers", "Valid Answer IDs", "Option ID", "Option", "Category", "Section"];
const questionOrderCols = ["Question Order", "Question ID", "Question", "Description","Category", "Answers", "All Sections For Question", "Sort Index (Dev Specific)"];
const qInOrderBySectionCols = ["Question Order", "Question ID", "Question", "Description", "Category", "Answers"];


export const dlQInOrder = (cols, sections, description="", translation) => {
  let rows = [];
  for (var section of sections) {
    let answers = {};
    const state = global.store.getState();
    let questions = questionsForSection(section, state.questions, state.options, answers, BOTH);
    questions.sort((a, b) => (getSortIndex(section, a.sortIndex) || 0) - (getSortIndex(section, b.sortIndex) || 0));
    questions.forEach((q, index) => {
      var allSections = getQuestionSections(q);
      var qNum = index + 1;
      var qNumStr = displaySections([section]) + ": " + qNum;
      var answerTxt = q.answers.map((a) => a.title).join("\n");
      var category = global.store.getState().categories.find((c) => c.id === q.category);
      var qTitle = q.title;
      var qDesc = q.description;
      var catTitle = category.title

      if(translation){
        var trQ = translation.questions.find(trQ => trQ.engID === q.id)
        if(trQ){
            qTitle = trQ.title
            qDesc = trQ.description
            let catTr = translation.categories.find((c) => c.engID === category.id)
            catTitle = catTr ? catTr.title : catTitle
            answerTxt = trQ.answers.map((a) => a.title).join("\n");
        }
      }

      
      rows.push({
        ...(cols.includes("Question Order") && {"Question Order": qNumStr}),
        ...(cols.includes("Question ID") && {"Question ID": q.id}),
        ...(cols.includes("Question") && {Question: qTitle.replace(/<.*?>/gm, '')}),
        ...(cols.includes("Description") && {Description: textVersion(qDesc)}),
        ...(cols.includes("Category") && {Category: textVersion(category.title)}),
        ...(cols.includes("Answers") && {Answers: answerTxt}),
        ...(cols.includes("All Sections For Question") && {"All Sections Containing Question": displaySections(allSections)}),
        ...(cols.includes("Sort Index (Dev Specific)") && {"Sort Index (Dev Specific)": q.sortIndex})
      });
    });
  }
  var data = Papa.unparse(rows);
  if(description.length > 0) { data = description + "\n" + data}
  var rptTitle = "Question Order"
  if(translation){ rptTitle = rptTitle + " - " + translation.title}
  downloadCSV(data, rptTitle)
}

export const dlQInOrderBySection = (cols, sectionArr) => {
  let rows = [];

  var sections = sectionArr[0].split(",");


  for (var section of sections) {
    let answers = {};
    const state = global.store.getState();
    let questions = questionsForSection(section, state.questions, state.options, answers, BOTH);
    questions.sort((a, b) => (getSortIndex(section, a.sortIndex) || 0) - (getSortIndex(section, b.sortIndex) || 0));
    questions.forEach((q, index) => {
      //only add if not already in the list (ie already answered in a previous section)
      if(!rows.find((e) => {return e["Question ID"] === q.id})){
        var qNum = index + 1;
        var qNumStr = displaySections([section]) + ": " + qNum;
        var answerTxt = q.answers.map((a) => a.title).join("\n");
        var category = global.store.getState().categories.find((c) => c.id === q.category);
        rows.push({
          ...(cols.includes("Question Order") && {"Question Order": qNumStr}),
          ...(cols.includes("Question ID") && {"Question ID": q.id}),
          ...(cols.includes("Question") && {Question: q.title.replace(/<.*?>/gm, '')}),
          ...(cols.includes("Description") && {Description: textVersion(q.description)}),
          ...(cols.includes("Category") && {Category: textVersion(category.title)}),
          ...(cols.includes("Answers") && {Answers: answerTxt})
        });
      }
    })
  }
  var data = Papa.unparse(rows);
  var titleStr = sections.reduce((str, section) => {
    switch(section) {
      case "monitoring":
        return (str+"DC_");
      case "assessment":
        return (str+"A_");
      case "controlRules":
        return (str+"MM_");
      default:
        return(str);
    }
  }, "")
  titleStr = titleStr.substring(0, titleStr.length - 1); //remove the extra ,
  titleStr = "Questionnaire Order-" + titleStr;
  downloadCSV(data, titleStr)
}

export const dlQuestions = (cols, sections) => {
  var questions = global.store.getState().questions.filter((q) => q.answerType === 'normal')
    .filter((question) => sections.some((section) => getQuestionSections(question).includes(section)))
    .map((question) => {
      var category = global.store.getState().categories.find((c) => c.id === question.category);
      var sections = getQuestionSections(question);
      var answerTxt = question.answers.map((a) => a.title).join("\n");
      return {
        ...(cols.includes("Question ID") && {"Question ID": question.id}),
        ...(cols.includes("Question") && {Question: textVersion(question.title)}),
        ...(cols.includes("Description") && {Description: textVersion(question.description)}),
        ...(cols.includes("Category") && {Category: textVersion(category.title)}),
        ...(cols.includes("Representation/Implementation") && {"Representation/Implementation": textVersion(question.representationCategory)}),
        ...(cols.includes("Sections") && {Sections: displaySections(sections)}),
        ...(cols.includes("Answers") && {Answers: answerTxt})
      };
    });
  var data = Papa.unparse(questions);
  downloadCSV(data, "Questions")
}


const displaySections = (sections) =>{
  var dispText = sections.map((section) => SECTION_TITLES[section]).join("\n")
  return dispText;
}

export const dlStaticCavs = (cols, sections) => {
  var staticCavs = [];
  global.store.getState().options.filter((option) => sections.includes(option.section)).map((option) => {
    var category = global.store.getState().categories.find((c) => c.id === option.category);
    option.additionalCaveats.forEach((addCav) => {
      staticCavs.push({
        ...(cols.includes("Option ID") && {"Option ID": option.id}),
        ...(cols.includes("Option Title") && {"Option Title": textVersion(option.title)}),
        ...(cols.includes("Static Caveat") && {"Static Caveat": addCav.title.replace(/"/g,"'")}),
        ...(cols.includes("Score") && {Score: addCav.score}),
        ...(cols.includes("Category") && {Category: category ? category.title : null}),
        ...(cols.includes("Section") && {Section: displaySections([option.section])})
      })
    });

  });
  var data = Papa.unparse(staticCavs);
  downloadCSV(data, "Static Caveats")
}

export const dlOptions = (cols, sections) => {
  var options = global.store.getState().options.filter((option) => sections.includes(option.section)).map((option) => {
    var category = global.store.getState().categories.find((c) => c.id === option.category);
    var inputCat = global.store.getState().categories.find((c) => c.id === option.inputCategory);
    var assessmentTierTitle = option.assessmentTier ? assessmentTiers.find(tier => tier.id === option.assessmentTier).title : "";
    return {
      ...(cols.includes("Option ID") && {"Option ID": option.id}),
      ...(cols.includes("Option Title") && {"Option Title": textVersion(option.title)}),
      ...(cols.includes("Description") && {Description: textVersion(option.description)}),
      ...(cols.includes("Assessment Output") && {"Assessment Output": textVersion(option.assessmentOutput)}),
      ...(cols.includes("Contacts") && {Contacts: textVersion(option.contacts)}),
      ...(cols.includes("References") && {References: textVersion(option.references)}),
      ...(cols.includes("Category (Output for Assessments)") && {"Category (Output for Assessments)": category ? category.title : null}),
      ...(cols.includes("Input Category (Assessments Only)") && {"Input Category (Assessments Only)": inputCat ? inputCat.title : null}),
      ...(cols.includes("Tier (Assessments Only)") && {"Tier (Assessments Only)": assessmentTierTitle}),
      ...(cols.includes("Section") && {Section: displaySections([option.section])})
    }
  });

  var data = Papa.unparse(options);
  downloadCSV(data, "Options");
}

export const dlCaveats = (cols, sections) => {
  var caveats = [];

  var questions = global.store.getState().questions.filter((q) => q.answerType === 'normal');
  questions.forEach((question) => {
    for (var optionID in question.domainLogic.caveats) {
      for (var answerID in question.domainLogic.caveats[optionID]) {
        var caveat = question.domainLogic.caveats[optionID][answerID];
        var answer = question.answers.find((a) => a.id.toString() === answerID.toString());
        var option = global.store.getState().options.find((o) => o.id.toString() === optionID.toString());
        var category = global.store.getState().categories.find((c) => c.id === option.category);
        if (caveat.title && caveat.title.length && answer && option && sections.includes(option.section)) {
          caveats.push({
            ...(cols.includes("Question ID") && {"Question ID": question.id}),
            ...(cols.includes("Question") && {Question: question.title.replace(/<.*?>/gm, '')}),
            ...(cols.includes("Answer ID") && {"Answer ID": answerID}),
            ...(cols.includes("Answer") && {Answer: answer.title}),
            ...(cols.includes("Caveat") && {Caveat: caveat.title}),
            ...(cols.includes("Score") && {Score: caveat.score}),
            ...(cols.includes("Option ID") && {"Option ID": optionID}),
            ...(cols.includes("Option") && {Option: option.title}),
            ...(cols.includes("Category") && {Category: category ? category.title : null}),
            ...(cols.includes("Section") && {Section: displaySections([option.section])})
          })
        }
      }
    }
  });

  var data = Papa.unparse(caveats);
  downloadCSV(data, "Caveats");
}

export const dlAnswers = (cols, sections) => {
  var answers = [];

  var questions = global.store.getState().questions.filter((q) => q.answerType === 'normal').filter((question) => sections.some((section) => getQuestionSections(question).includes(section)));
  questions.forEach((question) => {
    var sections = getQuestionSections(question)
    for (var answer of question.answers) {
      answers.push({
        ...(cols.includes("Question ID") && {"Question ID": question.id}),
        ...(cols.includes("Question") && {Question: question.title.replace(/<.*?>/gm, '')}),
        ...(cols.includes("Answer ID") && {"Answer ID": answer.id}),
        ...(cols.includes("Answer") && {Answer: answer.title}),
        ...(cols.includes("Sections") && {Sections: displaySections(sections)})
      })
    }
  });

  var data = Papa.unparse(answers);
  downloadCSV(data, "Answers");
}

export const dlCriteria = (cols, sections) => {
  var criteria = [];
  var questions = global.store.getState().questions.filter((q) => q.answerType === 'normal');
  var sbQuestions = global.store.getState().questions.filter((q) => q.answerType === 'satisfiedBy');
  questions = questions.concat(sbQuestions)
  questions.forEach((question) => {
    for (var optionID in question.domainLogic.criteria) {
      if (question.domainLogic.criteria[optionID]) {
        var answers = question.domainLogic.criteria[optionID].map((id) => {
          return question.answers.find((a) => a.id.toString() === id.toString())
        }).filter((a) => !!a);

        var option = global.store.getState().options.find((o) => o.id.toString() === optionID.toString());
        var category = global.store.getState().categories.find((c) => c.id === option.category);

        if (option && sections.includes(option.section)) {
          criteria.push({
            ...(cols.includes("Question ID") && {"Question ID": question.id}),
            ...(cols.includes("Question") && {Question: question.title.replace(/<.*?>/gm, '')}),
            ...(cols.includes("Valid Answers") && {"Valid Answers": answers.map((a) => a.title).join("\n")}),
            ...(cols.includes("Valid Answer IDs") && {"Valid Answer IDs": answers.map((a) => a.id).join("\n")}),
            ...(cols.includes("Option ID") && {"Option ID": optionID}),
            ...(cols.includes("Option") && {Option: option.title}),
            ...(cols.includes("Category") && {Category: category ? category.title : null}),
            ...(cols.includes("Section") && {Section: displaySections([option.section])})
          })
        }
      }
    }
  });

  var data = Papa.unparse(criteria);
  downloadCSV(data, "Criteria");
}

export const dlCavByOptionQuestion = (cols, sectionArr) => {
  //by convention, these dl functions take a cols and section array. cols is not needed will be received but ignored here and
  //we are only doing one section at a time for this so pull out the section from the array
  var section=sectionArr[0];
  var optionsList = global.store.getState().options;
  optionsList = optionsList.filter((option) => option.section === section);
  var questions = global.store.getState().questions.filter((q) => q.answerType === 'normal')
  var sectionQuestions = questionsForSection(section, questions, global.store.getState().options, "", CAV)

  var titleArr = [];
  var questionDescArr = ["Question Description","","",""];
  var possibleAnsArr = ["Possible Answers","","",""];
  titleArr.push("ID");
  titleArr.push("Option Name");
  if(section === "assessment"){
    titleArr.push("Output Category")
    titleArr.push("Input Category");
    titleArr.push("Assessment Tier");
    questionDescArr.push("","");
    possibleAnsArr.push("","");
  } else {
    titleArr.push("Category")
  }
  titleArr.push("Static Caveats");

  sectionQuestions.forEach((question) => {
    titleArr.push(question.id + ":" + question.title.replace(/<.*?>/gm, ''));
    questionDescArr.push(textVersion(question.description));
    possibleAnsArr.push(question.answers.map((a) => a.title).join("\n"));
  })

  var finalArr = [];
  finalArr.push(titleArr, questionDescArr, possibleAnsArr);


  optionsList.forEach((option) => {
    var rowArr = [];
    rowArr.push(option.id);
    rowArr.push(option.title);
    var category = global.store.getState().categories.find((c) => c.id === option.category);
    rowArr.push(category ? category.title : "",);
    if(section === "assessment"){
      var inputCat = global.store.getState().categories.find((c) => c.id === option.inputCategory);
      rowArr.push(inputCat ? inputCat.title : "",);
      let assessmentTierTitle = assessmentTiers.find(tier => tier.id === option.assessmentTier).title;
      rowArr.push(assessmentTierTitle ? assessmentTierTitle : "",);
    }

    //static caveats
    var staticCavs = [];
    global.store.getState().options.map((option) => {
      var category = global.store.getState().categories.find((c) => c.id === option.category);
      option.additionalCaveats.forEach((addCav) => {
        staticCavs.push({
          option_id: option.id,
          title: option.title,
          static_Caveat: addCav.title,
          score: addCav.score,
          category: category ? category.title : null,
          section: option.section
        })
      });

    });
    var sCavsForOpt = staticCavs.filter(sCav => sCav.option_id.toString() === option.id.toString());
    var sCavText = sCavsForOpt.map((sCav) => sCav.static_Caveat).join("\n")
    rowArr.push(sCavText);

    //caveats for options
    var caveats = [];
    var questions = global.store.getState().questions.filter((q) => q.answerType === 'normal');
    questions.forEach((question) => {
      for (var optionID in question.domainLogic.caveats) {
        for (var answerID in question.domainLogic.caveats[optionID]) {
          var caveat = question.domainLogic.caveats[optionID][answerID];
          var answer = question.answers.find((a) => a.id.toString() === answerID.toString());
          var option = global.store.getState().options.find((o) => o.id.toString() === optionID.toString());
          if (caveat.title && caveat.title.length && answer && option) {
            caveats.push({
              question: question.title.replace(/<.*?>/gm, ''),
              answer: answer.title,
              caveat: caveat.title,
              score: caveat.score,
              option: option.title,
              category: option.category,
              section: option.section,
              option_id: optionID,
              answer_id: answerID,
              question_id: question.id
            })
          }
        }
      }
    });

    var cavsForOpt = caveats.filter(cav => cav.option_id.toString() === option.id.toString())
    sectionQuestions.forEach((question) => {
      var exists = cavsForOpt.filter((cav) => cav.question_id === question.id)
      if(exists.length) {
        var answerStr = "";
        exists.forEach((cav) => {
          answerStr +=  toColorStr(cav.score) + ": " + cav.answer + " : " + cav.caveat + "\n"
        })
        answerStr = answerStr.substring(0, answerStr.length - 1); //remove extra \n
        rowArr.push(answerStr);
      } else {
        rowArr.push("");
      }
    })
      finalArr.push(rowArr);
  })

  var data = Papa.unparse(finalArr);
  downloadCSV(data, SECTION_TITLES[section] + " Caveats OptxQ");
}

export const dlCritByOptionQuestion = (cols, sectionArr) => {
  //by convention, these dl functions take a cols and section array. cols is not needed will be received but ignored here and
  //we are only doing one section at a time for this so pull out the section from the array
  var section=sectionArr[0];
  var optionsList = global.store.getState().options;
  optionsList = optionsList.filter((option) => option.section === section);
  var questions = global.store.getState().questions.filter((q) => q.answerType === 'normal');
  var sectionQuestions = questionsForSection(section, questions, global.store.getState().options, "", CRIT);
  var sbQuestions = global.store.getState().questions.filter((q) => q.answerType === 'satisfiedBy');

  var titleArr = [];
  var questionDescArr = ["Question Description","",""];
  var possibleAnsArr = ["Possible Answers","",""];
  titleArr.push("ID")
  titleArr.push("Option Name")
  if(section === "assessment"){
    titleArr.push("Output Category")
    titleArr.push("Input Category")
    titleArr.push("Assessment Tier")
    questionDescArr.push("","");
    possibleAnsArr.push("","");
  } else {
    titleArr.push("Category")
  }

  sectionQuestions.forEach((question) => {
    titleArr.push(question.id + ":" + question.title.replace(/<.*?>/gm, ''));
    questionDescArr.push(textVersion(question.description));
    possibleAnsArr.push(question.answers.map((a) => a.title).join("\n"));
  })
  if(section === "assessment"){
    sbQuestions.forEach((sbQ) => {
      titleArr.push(sbQ.id + ":" + sbQ.title.replace(/<.*?>/gm, ''))
    })
  }

  var finalArr = [];
  finalArr.push(titleArr, questionDescArr, possibleAnsArr);

  //criteria array
  var criteria = [];

  questions = global.store.getState().questions.filter((q) => q.answerType === 'normal');
  questions.forEach((question) => {
    for (var optionID in question.domainLogic.criteria) {
      if (question.domainLogic.criteria[optionID]) {
        var answers = question.domainLogic.criteria[optionID].map((id) => {
          return question.answers.find((a) => a.id.toString() === id.toString())
        }).filter((a) => !!a);
        var option = global.store.getState().options.find((o) => o.id.toString() === optionID.toString());
        if (option) {
          criteria.push({
            question: question.title.replace(/<.*?>/gm, ''),
            valid_answers: answers.map((a) => a.title).join(";"),
            option: option.title,
            option_id: optionID,
            category: option.category,
            section: option.section,
            question_id: question.id
          })
        }
      }
    }
  });

  var critForOpt;
  optionsList.forEach((option) => {
    var rowArr = [];
    rowArr.push(option.id);
    rowArr.push(option.title);
    var category = global.store.getState().categories.find((c) => c.id === option.category);
    rowArr.push(category ? category.title : "",);
    if(section === "assessment"){
      var inputCat = global.store.getState().categories.find((c) => c.id === option.inputCategory);
      rowArr.push(inputCat ? inputCat.title : "",);
      let assessmentTierTitle = assessmentTiers.find(tier => tier.id === option.assessmentTier).title;
      rowArr.push(assessmentTierTitle ? assessmentTierTitle : "",);
    }
    critForOpt = criteria.filter(crit => crit.option_id.toString() === option.id.toString())

    var answerStr = "";
    sectionQuestions.forEach((question) => {
      var exists = critForOpt.filter((crit) => crit.question_id === question.id)
      if(exists.length) {
        answerStr =  exists[0].valid_answers
        answerStr = answerStr.replace(/;/g, "\n")
        rowArr.push(answerStr);
      } else {
        rowArr.push("");
      }
    })

    //for assessment section
    //filter questions if they have option in the domainLogic then list all answers
    if(section === "assessment"){
      sbQuestions.forEach((sbQ) => {
        var satisfyingQuestions = questions.filter((q) => sbQ.satisfiedBy.includes(q.id));
        if(sbQ.domainLogic.criteria.hasOwnProperty(option.id) && sbQ.domainLogic.criteria[option.id] !== null){
          var answers = sbQ.domainLogic.criteria[option.id].map((id) => {
            return sbQ.answers.find((a) => a.id.toString() === id.toString())
          }).filter((a) => !!a);
          answerStr = answers.map((a) => {
            var question = satisfyingQuestions.find((q) => q.answers.map((ans) => ans.id).includes(a.id))
            return question.title.replace(/<.*?>/gm, '').replace(/\n/gm,'') + " " + question.answers.find(ans => ans.id === a.id).title;
          }).join("\n")
          rowArr.push(answerStr);
        } else {
          rowArr.push("");
        }
      })
    }

    finalArr.push(rowArr);
  })

  var data = Papa.unparse(finalArr);
  downloadCSV(data, SECTION_TITLES[section] + " Criteria OptxQ");
}

export const CAV = 0;
export const CRIT = 1;
export const BOTH = 2;

export const questionsForSection = (section, questions, options, answers, cavOrCrit) => {
  let includeCavs = (cavOrCrit === CAV || cavOrCrit === BOTH);
  let includeCrit = (cavOrCrit === CRIT || cavOrCrit === BOTH);

  let lookup = createOptionSectionLookup(options);

  let satisfiedByQuestionsInSection = questions.filter((question) => {
    let caveats = question.domainLogic.caveats;
    if (!question.satisfiedBy || !question.satisfiedBy.length) {
      return false;
    }
    for (var optionID in caveats) {
      if (lookup[section][optionID] === true) {
        return true;
      }
    }
    let criteria = question.domainLogic.criteria;
    for (var optionID in criteria) {
      if (lookup[section][optionID] === true && criteria[optionID] && criteria[optionID].length) {
        return true;
      }
    }
    return false;
  });
  let neededToSatisfy = [];
  for (let question of satisfiedByQuestionsInSection) {
    neededToSatisfy = neededToSatisfy.concat(question.satisfiedBy || []);
  }

  const result = questions.filter((question) => {
    if (question.answerType === 'satisfiedBy') {
      return false;
    }
    if (answers[question.id] && (answers[question.id].value && question.answers.map((a) => a.id).indexOf(answers[question.id].value) !== -1) && answers[question.id].answeredInSection !== section) {
      return false;
    }
    if(includeCavs){
      let caveats = question.domainLogic.caveats;
      for (var optionID in caveats) {
        if (Object.keys(caveats[optionID]).length) {
          if (lookup[section][optionID] === true) {
            return true;
          }
        }
      }
    }
    if(includeCrit){
      let criteria = question.domainLogic.criteria;
      for (var optionID in criteria) {
        if (lookup[section][optionID] === true && criteria[optionID] && criteria[optionID].length) {
          return true;
        }
      }

      if (neededToSatisfy.indexOf(question.id) !== -1) {
        return true;
      }
    }
    return false;
  })
  return result;
}

export const toColorStr = (score) => {
  switch(score){
    case -3:
      return "Red"
    case -2:
      return "Orange";
    case -1:
      return "Yellow";
    case 0:
      return "Grey";
    case 2:
      return "Green";
    default:
      return score.toString();
  }
}
